<template>
  <div>
    <main>
      <slot />
    </main>
  </div>
</template>
